import { Box } from '@mui/material';
import Table, { ColumnsType } from 'antd/es/table';
import DataType from '../../../Functions/Traitement/DataPeriodMbloquer';

const Tab7 = (props: { form?: any, DataMontantBloque: DataType[] }) => {

    const columns: ColumnsType<DataType> = [
        {
            title: 'Date creation',
            dataIndex: 'DATCRE',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'Date fin ',
            dataIndex: 'DATEFM',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'Reference',
            dataIndex: 'REFMARQ',
            ellipsis: true,
            width: 150,
            onFilter: (value: any, record: any) => {
                return String(record.REFMARQ)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.codage)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.NUMCPT)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.NOMCPT)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'Nom',
            dataIndex: 'NOMCPT',
            ellipsis: true,
            width: 250,
        },
        {
            title: 'Montant bloque',
            dataIndex: 'MONTPR',
            ellipsis: true,
            width: 150,
            align:"right"
        },
        {
            title: 'Motif blocage',
            dataIndex: 'MOTIFM',
            ellipsis: true,
            width: 250,
        }
    ];

    return (
        <div className='tabItem'>
            <div >
                <Box display={'flex'} fontStyle="inherit" width={"85%"} position={"absolute"} >
                    <Box fontStyle="inherit" className='bordure1'>
                        <legend>Montant Bloqué </legend>
                        <Table size='small' dataSource={props.DataMontantBloque} columns={columns} style={{ width: '100%' }} scroll={{ y: 350,x: 1300 }} />
                    </Box>
                </Box>
            </div>
        </div>

    );

}

export default Tab7;